export default __webpack_public_path__ + "static/media/clouds.331ebee2.png";